export default "__VITE_ASSET__wRPYvJEO__"